export default __webpack_public_path__ + "static/media/4.43efb6e6.webp";